/**
 * Milliseconds for sorting/display. Backend sends LocalDateTime as "yyyy-MM-dd HH:mm:ss"
 * (no timezone). `new Date("... ...")` is invalid in some browsers; normalize first.
 */
function parseBackendLocalDateTimeMs(value) {
  if (value == null || value === '') return 0;
  if (Array.isArray(value)) {
    const [y, mo, d, h = 0, mi = 0, s = 0, nano = 0] = value;
    const ms = new Date(
      y,
      mo - 1,
      d,
      h,
      mi,
      s,
      Math.floor(Number(nano) / 1e6) || 0,
    ).getTime();
    return Number.isFinite(ms) ? ms : 0;
  }
  if (typeof value === 'object' && value !== null && 'year' in value) {
    try {
      const t = new Date(
        value.year,
        value.monthValue - 1,
        value.dayOfMonth,
        value.hour || 0,
        value.minute || 0,
        value.second || 0,
      ).getTime();
      return Number.isFinite(t) ? t : 0;
    } catch (e) {
      return 0;
    }
  }
  const s = String(value).trim();
  if (!s || s === 'null') return 0;
  let candidate = s;
  if (!s.includes('T') && /^\d{4}-\d{2}-\d{2}\s+\d{1,2}:\d{2}/.test(s)) {
    candidate = s.replace(/\s+/, 'T');
  }
  let parsed = Date.parse(candidate);
  if (Number.isFinite(parsed)) return parsed;
  parsed = new Date(candidate).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

module.exports = { parseBackendLocalDateTimeMs };
